import React from 'react'
import SEO from '../components/SEO'
import Layout from '../components/layout'
import { graphql, useStaticQuery } from "gatsby";
import './portfolio.scss'
import Skills from '../components/portfolio/Skills'

const AboutPage = () => {
    const data = useStaticQuery(graphql`
    {
       
      markdownRemark(frontmatter: { id: { eq: "about-me" } }) {
        html
      }
    }
  `);
  

    return (
        <Layout>
              <SEO
              title="About Me"
              description="Hi I am Chintan Agrawal. Welcome to my space on web "
              />
          <main className="portfolio">
                    <div width ={70}>
                        <div 
                        className="text-justify"
                        dangerouslySetInnerHTML={{ __html: data.markdownRemark.html }}
                        />    
                    </div>
                    <Skills></Skills>
            </main>
        </Layout> 
              
 
 
    )
}

export default AboutPage